import axios from 'axios'

// 创建axios实例
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    const res = response.data
    if (res && res.code === -4) {
      console.log('res', res)
      try { localStorage.removeItem('token') } catch (_) { }
      window.location.href = '/login'
      return Promise.reject(new Error('Unauthorized'))
    }
    return res
  },
  error => {
    console.error('API请求错误:', error)
    return Promise.reject(error)
  }
)
// 机构（organization）相关接口
export const organizationAPI = {
  // 获取机构列表，参数：{ pageNum, pageSize }
  getList: (data) => api.post('/organization/list', data),

  // 添加机构，参数：{ name }
  add: (data) => api.post('/organization/add', data),

  // 编辑机构，参数：{ id, name }
  edit: (data) => api.post('/organization/edit', data),

  // 删除机构，参数：{ id }
  del: (data) => api.post('/organization/del', data)
}




// 用户认证相关接口
export const authAPI = {
  // 用户登录
  login: (data) => api.post('/login', data),

  // 管理员注册
  register: (data) => api.post('/register', data),

  // 管理员列表
  adminList: (data) => api.post('/adminList', data),

  // 管理员编辑
  adminEdit: (data) => api.post('/adminEdit', data),

  // 管理员删除
  adminDel: (data) => api.post('/adminDel', data),

  // 个人信息修改
  updateUser: (data) => api.post('/user/update', data),

  // 重置密码
  resetPassword: (data) => api.post('/user/resetPassword', data),

  // 个人信息详情
  getUserInfo: () => api.post('/user/info')
}

// 护士管理相关接口
export const nurseAPI = {
  // 分页查护士列表，支持 name、phone 筛选
  getNurseList: (data) => api.post('/nurse/list', data),

  // 按 nurseId 分页查该护士名下患者，支持 userId、name、phone 筛选
  getNursePatients: (data) => api.post('/nurse/patients', data),
}

// 医生管理相关接口
export const doctorAPI = {
  // 医生信息修改
  updateDoctor: (data) => api.post('/doctor/update', data),

  // 医生信息详情
  getDoctorInfo: (data) => api.post('/doctor/info', data),

  // 医生删除
  deleteDoctor: (data) => api.post('/doctor/del', data),

  // 添加医生
  addDoctor: (data) => api.post('/doctor/add', data),

  // 获取医生列表
  getDoctorList: (data) => api.post('/doctor/list', data),

  // 重置医生密码
  resetPassword: (data) => api.post('/user/resetPassword', data)
}

// 消息相关接口
export const messageAPI = {
  // 消息列表
  messageList: (data) => api.post('/message/list', data),
  //消息数量
  messageListNum: (data) => api.post('/message/listNum', data),

  // 添加消息
  addMessage: (data) => api.post('/message/add', data)
}

// ai相关接口
export const agentAPI = {
  // 获取聊天记录
  chatHistory: (data) => api.post('/agent/chatHistory', data),

  // 获取智能体
  getDatasetsList: (data) => api.post('/agent/datasets/list', data),

  // 获取智能体内文件列表
  getDocumentList: (data) => {
    const { dataset_id, ...otherParams } = data
    return api.post(`/agent/datasets/${dataset_id}/document/list`, otherParams)
  },

  // 删除智能体内文件
  delFileDocument: (dataset_id, document_id) => api.post(`/agent/datasets/${dataset_id}/document/${document_id}/delFile`),

  // 下载智能体内文件
  getFileDocument: (dataset_id, document_id) => api.post(`/agent/datasets/${dataset_id}/document/${document_id}/getfile`),


  // 上传添加智能体内文件
  addFileDocument: (data, datasetId) => api.post(`/agent/datasets/${datasetId}/document/addFile`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 患者管理相关接口
export const patientAPI = {
  // 获取患者列表
  getPatientList: (data) => api.post('/patient/list', data),

  // 获取患者详情
  getPatientDetail: (data) => api.post('/patient/detail', data),
  // 智能选项数据
  getRandomDialogueQA: (data) => api.post('/patient/getRandomDialogueQA', data),

  // 新增患者
  addPatient: (data) => api.post('/patient/add', data),

  // 更新患者信息
  updatePatient: (data) => api.post('/patient/update', data),

  // 删除患者
  deletePatient: (data) => api.post('/patient/del', data),

  // 修改患者关联的护士
  assignNurse: (data) => api.post('/patient/assignNurse', data),

  // 管理员修改病人密码
  updatePassword: (data) => api.post('/patient/updatePassword', data),

  // 患者排班
  paiban: (data) => api.post('/patient/paiban', data),
  // 获取前十条的体重历史记录
  getWeightNewList: (data) => api.post('/patient/weight/newList', data),
  getWeightNewListInfo: (data) => api.post('/patient/weight/newListInfo', data),

  // 获取体重历史记录
  getWeightHistory: (data) => api.post('/patient/weight/history', data),

  // 修改体重历史记录
  updateWeightHistory: (data) => api.post('/patient/weight/update', data),

  // 添加体重历史记录
  addWeightHistory: (data) => api.post('/patient/weight/add', data),

  // 删除体重历史记录
  deleteWeightHistory: (data) => api.post('/patient/weight/del', data),

  // 血压计绑定状态
  getDeviceBindInfo: (data) => api.post('/patient/device/bindInfo', data),
  // 帮患者绑定血压计
  bindDevice: (data) => api.post('/patient/device/bind', data),
  // 帮患者解绑血压计
  unbindDevice: (data) => api.post('/patient/device/unbind', data),
  // 最近一次血压
  getPressureLatest: (data) => api.post('/patient/pressure/latest', data),
  // 血压历史分页
  getPressureHistory: (data) => api.post('/patient/pressure/history', data),
  // 血压总览列表：患者 + 绑定 + 最近血压
  getPressureList: (data) => api.post('/patient/pressure/list', data)
}

// 审批相关接口
export const approvalAPI = {
  // 获取审批列表
  getApprovalList: (data) => api.post('/approval/list', data),

  // 审批
  approval: (data) => api.post('/approval/review', data),

  // 提交审批
  submitApproval: (file, data) => {
    const formData = new FormData();
    console.log(file, data)
    const jsonData = JSON.stringify(data);
    const blobData = new Blob([jsonData], { type: "application/json" })
    formData.append('file', file)
    formData.append('data', blobData)


    return api.post('/approval/submit', formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },

  // 下载审批文件
  downloadFile: (filename) => api.get(`/approval/download?filename=${filename}`, {
    responseType: 'blob'
  }),

  // 下载审批文件
  downloadFile1: (filename) => api.get(`/public/file/download?fileName=${filename}`, {
    responseType: 'blob',
    headers: {
      'Accept': '*/*'
    }
  })
}

// 问卷相关接口
export const questionnaireAPI = {
  // 获取问卷列表
  getQuestionnaireList: (data) => api.post('/questionnaire/list', data),

  // 获取问卷详情
  getQuestionnaireDetail: (data) => api.post('/questionnaire/detail', data)
}

// 文件相关接口
export const fileAPI = {
  // 下载文件
  downloadFile: (filename) => api.get(`/public/file/download?fileName=${filename}`, {
    responseType: 'blob',
    headers: {
      'Accept': '*/*'
    }
  })
}

// 广告位Banner相关接口
export const adBannerAPI = {
  // 添加banner图
  add: (data) => api.post('/adbanner/add', data),

  // 删除banner图
  del: (data) => api.post('/adbanner/del', data),

  // 获取banner图列表
  list: (data) => api.post('/adbanner/list', data),

  // 上传banner图图片
  uploadPic: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/adbanner/pic/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // 更新banner图
  update: (data) => api.post('/adbanner/update', data)
}

// VIP图片相关接口
export const vipImageAPI = {
  // 获取 VIP 背景图片
  getBackground: () => api.post('/adbanner/getQCbackground'),

  // 上传并添加 VIP 背景图片（单一接口完成上传与添加）
  uploadAndAdd: (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/adbanner/upQCbackground', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}


// VIP商城大类相关接口
export const vipTagsAPI = {
  // 获取 VIPTags 列表
  getVipList: (data) => api.post('/vip/getTagInfo', data),
  updateVip: (data) => api.post('/vip/editTags', data),
  delVip: (data) => api.post('/vip/delTags', data),
  addVip: (data) => api.post('/vip/addTags', data),
}
// VIP商城相关接口
export const vipAPI = {
  // 获取 VIP 列表
  getVipList: (data) => api.post('/vip/vipList', data),
  updateVip: (data) => api.post('/vip/updateVip', data),
  delVip: (data) => api.post('/vip/delVip', data),
  addVip: (data) => api.post('/vip/add', data),
}
// VIP订单列表相关接口
export const vipOrderListAPI = {
  // 获取 VIP用户开通订单 列表
  getVipList: (data) => api.post('/vip/getOrderList', data),
}
// 八天干体重报告相关接口
export const eightDayWeightReportAPI = {
  // 获取 八天干体重报告 列表
  getReportList: (data) => api.post('/report/getReport', data),
  // 编辑 八天干体重报告
  editReportList: (data) => api.post('/report/editReport', data),
}
// 干体重活动相关接口
export const ActivityAPI = {
  // 获取 干体重活动 列表
  getReportList: (data) => api.post('/report/getActivityList', data),
  //编辑 干体重活动选中项
  editActivityOP: (data) => api.post('report/editActivityOP', data),
  // 编辑 干体重活动
  editReportList: (data) => api.post('/report/editActivityList', data),
  // 删除 干体重活动
  delActivityList: (data) => api.post('/report/delActivityList', data),
  //获取用户活动详情
  getDayQuestionnaire: (data) => api.post('/report/getDayQuestionnaire', data),
}
// 金币管理相关接口
export const coinWithdrawAPI = {
  // 用户金币余额列表
  getAccountList: (data) => api.post('/admin/coin/account/list', data),
  // 金币流水列表
  getLedgerList: (data) => api.post('/admin/coin/ledger/list', data),
  // 提现申请列表
  getList: (data) => api.post('/admin/coin/withdraw/list', data),
  // 审核通过
  approve: (data) => api.post('/admin/coin/withdraw/approve', data),
  // 审核驳回
  reject: (data) => api.post('/admin/coin/withdraw/reject', data),
  // 标记已付款
  paid: (data) => api.post('/admin/coin/withdraw/paid', data)
}

// 机构管理员相关接口
export const organizationManagerAPI = {
  // 添加机构管理员，参数：{ id, account, password }
  addManager: (data) => api.post('/organization/addManager', data),

  // 编辑管理员密码，参数：{ roleId, password }
  editManager: (data) => api.post('/organization/editManager', data),

  // 获取管理员列表，参数：{ pageNum, pageSize, id }
  listManager: (data) => api.post('/organization/listManager', data),

  // 删除管理员，参数：{ roleId }
  delManager: (data) => api.post('/organization/delManager', data)
}

export default api 
